import { Injectable, isDevMode, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash-es';

export interface IJavaConnector {
    goBack: () => void;
    gotoTRAdmin: () => void;
    setDestination: (route: string) => void;
    sendPost: (url: string, json: string) => string;
    sendGet: (url: string) => string;
    getLastScanned: () => string;
    shitBills: (amount: number) => number;
}

const getDataSynchronous = (method: string, url: string, data?: any) => {
    var request = new XMLHttpRequest();

    request.open(method, url, false);  // `false`
    // makes the request synchronous

    request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    request.send(data);

    if (request.status === 200) {
        return request.response;
    } else {
        throw new Error('request failed');
    }
}
const http = (url: string, data?: any) => {
    const method = data ? 'POST' : 'GET';
    const res = getDataSynchronous(method, url, data);

    return res;
}

// this is getting complicated and should exist elsewhere
const fakeJC = () => ({
    goBack: () => {
        alert('going back in jfx');
    },
    gotoTRAdmin: () => {
        alert('going to TR Admin in jfx');
    },
    setDestination: (route: string) => alert('going to ' + route),
    sendGet: (url: string) => {
        return (http(url));
    },
    sendPost: (url: string, json: string) => {
        const p = JSON.parse(json);

        p['Session Key'] = '928d9ce467f76b047e358bd874dfb1ecdb06c22ee339d611d34912eb156a4555';
        p['Machine ID'] = '00001-001-1-00001';

        return http(url, JSON.stringify(p));
    },
    getLastScanned: () => {
        return _.get(window, 'lastScanned', '') as string;
    },
    shitBills: (amount: number) => {
        alert(`requested to shit ${amount} bills, but none ejected`);

        return 0;
    },
} as IJavaConnector);

@Injectable({
    providedIn: 'root'
})
export class JavaService {

    get javaConnector() {
        const w = window as any;
        const js = w.javaConnector as IJavaConnector;

        if (!js) {
            if (!isDevMode()) {
                this._router.navigate(['/jc-error']);
            } else {
                return fakeJC();
            }
        }

        return js;
    }

    constructor(
        private _router: Router,
        private _zone: NgZone,
    ) {
        const w = window as any;

        w.getJsConnector = () => {
            return this;
        }
    }

    javaReady(route: string) {
        this._zone.run(() => {
            this._router.navigate([route]);
        });
    }
}
